import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';
import { IEmployee } from '.';


export class ICootjeEmployee extends BaseEntity {
    employeeId: string;
    employee: IEmployee;
    diensten: ICootjeDienst[];
}

export class ICootjeDienst extends BaseEntity {
    dienstId: string;
    professionalName: string;
    pOnummerGUID: string;
    boekinscodeGUID: string;
    factuurnummer: string;
    datumDienst: string;
    aantalUren: number;
    whiteLabelName: string;
}

export class CootjeService extends BaseService<ICootjeEmployee> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'finance/cootje');
    }

    public sendToCootje(diensten): ng.IPromise<any> {
        return this.Restangular.all(this.itemName).one('sendToCootje').customPOST(diensten).then((item) => {
            return item;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/cootje.service.ts